import TransactionHistoryModalContainer from './containers/TransactionHistoryModalContainer'

export default TransactionHistoryModalContainer
